import { createAction } from '@ngrx/store';

export const loaderAnimationShow = createAction('[Loader-animation] Show');

export const loaderAnimationHide = createAction('[Loader-animation] Hide');
